import styled from 'styled-components';
import media from 'styled-media-query';

export const DropDown = styled.div<{
  active?: boolean;
  minHeight?: string;
  numberOfErrors?: number;
}>`
  width: 100%;
  height: 48px;
  min-height: 48px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  border-radius: 6px;
  padding: 0px 19.5px 20px;
  transition: all 0.3s ease-out;
  background: rgba(255, 255, 255, 0.1);
  margin-bottom: 12px;

  svg {
    transform: rotateZ(90deg);
    transition: all 0.3s ease-in-out;
    color: ${(props) => props.theme.palette.background.light};
  }

  ${(props) =>
    props.active &&
    (() => {
      switch (props.numberOfErrors) {
        case 0:
          return 'height: auto;';

        case 1:
          return 'height: 414.91px';

        case 2:
          return 'height: 459.8px';

        default:
          return 'height: auto;';
      }
    })()}
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 0 15px 0;
  cursor: pointer;
`;

export const Title = styled.h2`
  color: ${(props) => props.theme.palette.background.light};
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  font-size: ${(props) => props.theme.typography.fontSizeRegular - 0.6}rem;
`;

export const Subtitle = styled.p`
  color: ${(props) => props.theme.palette.text.white};
  font-weight: 400;
  font-size: ${(props) => props.theme.typography.fontSize}rem;
  font-family: 'Roboto';
  margin-bottom: 12px;
  width: 100%;
`;

export const Text = styled.p`
  color: #ffffff61;
  font-weight: 400;
  font-size: ${(props) => props.theme.typography.fontSize}rem;
  font-family: 'Roboto';
  margin-top: 5px;
  margin-bottom: 12px;
  width: 100%;
`;

export const GetCode = styled.button`
  background: transparent;
  color: #e49824;
  position: absolute;
  right: 17.25px;
  top: 15px;
  border: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 24px;
  cursor: pointer;
`;

export const PhoneCodeContainer = styled.div`
  display: none;
  width: 100%;

  ${media.lessThan('medium')`
    display: block;
    margin-bottom: 12px;
  `};

  .css-1wc848c-MuiFormHelperText-root {
    font-size: 1.2rem;
  }
`;
